<template>
	<div>
		<Header />

		<div>
			<Carousel loop :height="350" arrow="never" dots="none">
				<CarouselItem>
					<div class="banner">
						<div>
							<p class="pageType">股权类服务</p>
						</div>
					</div>
				</CarouselItem>
			</Carousel>
			<div>
				<div class="serviceIntroduction">
					<ul class="serviceTypeList">
						<p>股权类服务</p>
						<li v-for="(item,i) in data" :class="{'active':i+1==type}" @click="skipService(i)">
							{{item.title}}
						</li>
					</ul>
					<div class="introductionInfo">
						<p>{{data[type-1].title}}</p>
						<div class="serviceContent">
							<component :is="data[type-1].component"></component>
						</div>
					</div>
					
					 <div style="clear: both;"></div>
				</div>

			</div>

		</div>

		<ContactUs />
		<Footer />
	</div>
</template>

<script>
	import Header from '@/common/header'
	import Footer from '@/common/footer.vue'
	import ContactUs from '@/common/contactUs.vue'
	import RegionalShareholding from '@/views/services/equity/components/regionalEquityMarket.vue'
	import StockOwnershipIncentive from '@/views/services/equity/components/stockOwnershipIncentive.vue'
	import ShareReform from '@/views/services/equity/components/shareReform.vue'
	import EquityInvestmentFinancing from '@/views/services/equity/components/equityInvestmentFinancing.vue'
	
	import {
		merge
	} from 'lodash'

	export default {
		components: {
			Header,
			Footer,
			ContactUs,
			RegionalShareholding,
			StockOwnershipIncentive,
			ShareReform,
			EquityInvestmentFinancing

		},
		data() {
			return {
				type: this.$route.query.type,
				data: [{
					title: '区域性股权市场挂牌',
					component: 'RegionalShareholding'
				}, {
					title: '股权激励筹划',
					component: 'StockOwnershipIncentive'
				}, {
					title: '合规股改方案咨询',
					component: 'ShareReform'
				}, {
					title: '股权投融资',
					component: 'EquityInvestmentFinancing'
				}]

			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);

		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			handleScroll() {
				if (window.pageYOffset >= 410) {
					$('.serviceTypeList').addClass('service-fixed')

				} else {
					$('.serviceTypeList').removeClass('service-fixed')
				}

			},
			skipService(i){
				this.type=i+1
				
				this.$router.push({
					query: merge({}, {
						'type': i+1
					})
				})
			}


		}


	}
</script>

<style scoped lang="less">
	.banner {
		background: url(../../../assets/img/service/banner.png) center center no-repeat
	}
</style>